/**
 * Hook for sidebar user display logic.
 *
 * Encapsulates the "anonymous users appear logged out" pattern.
 * Returns null for anonymous users so sidebar shows sign-in prompt.
 */

import { useAuthStore } from "../store";

export interface SidebarUser {
  name: string;
  role: string;
  email?: string;
  avatarUrl?: string;
}

export function useSidebarUser(): SidebarUser | null {
  const user = useAuthStore((s) => s.user);

  // Anonymous users should appear as "logged out" in UI
  if (!user || user.isAnonymous) {
    return null;
  }

  return {
    name: user.name ?? user.email?.split("@")[0] ?? "Guest",
    role: user.role,
    ...(user.email && { email: user.email }),
    ...(user.image && { avatarUrl: user.image }),
  };
}
